import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=f6da3706&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=f6da3706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6da3706",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6da3706')) {
      api.createRecord('f6da3706', component.options)
    } else {
      api.reload('f6da3706', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=f6da3706&scoped=true&", function () {
      api.rerender('f6da3706', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rpRBnaeS0D7f/JS/comp/Voucher.vue"
export default component.exports